import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine8 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#D282BE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6197 14.9898C16.6197 13.2443 15.5496 12.193 14.3301 11.6113C15.5687 10.8603 16.2068 9.90313 16.2068 8.66426C16.2068 6.39287 14.2735 5.24791 11.946 5.24791C9.67458 5.24791 7.68493 6.76826 7.68493 8.96452C7.68493 10.3346 8.39815 11.142 9.54336 11.855C8.26693 12.5121 7.27197 13.5443 7.27197 15.3086C7.27197 17.317 8.94258 19.0816 11.8896 19.0816C14.6113 19.0816 16.6197 17.5051 16.6197 14.9898ZM13.6727 8.83304C13.6727 9.65895 12.9221 10.4285 12.2277 10.7476C11.383 10.391 10.2941 9.80895 10.2941 8.72034C10.2941 7.80052 10.9513 7.16217 11.9838 7.16217C13.0721 7.16243 13.6727 7.91347 13.6727 8.83304ZM13.8793 15.1962C13.8793 16.2472 13.1848 17.1297 11.9272 17.1297C10.6508 17.1297 9.93754 16.0972 9.93754 15.0083C9.93754 13.9761 10.8013 13.1126 11.6645 12.7748C12.7907 13.338 13.8793 13.9949 13.8793 15.1962Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgLine8);
export { ForwardRef as ReactComponent };
